export const VALIDATOR_PRIORITY_HIGH = 1;
export const VALIDATOR_PRIORITY_MEDIUMHIGH = 2;
export const VALIDATOR_PRIORITY_MEDIUM = 3;
export const VALIDATOR_PRIORITY_MEDIUMLOW = 4;
export const VALIDATOR_PRIORITY_LOW = 5;


// WEBPACK FOOTER //
// ./src/base/scripts/constraints/ConstraintValidatorPriorities.js